"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const md_1 = require("react-icons/md");
const IconButton_1 = require("../Button/IconButton");
const classnames_1 = __importDefault(require("classnames"));
function ModalHeader({ onCloseButtonClick, children, hasBorder = true, className }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)('h-16', 'flex', 'items-center', 'justify-between', 'px-6', {
            'border-b border-b-silver-20': hasBorder
        }, className) }, { children: [children, (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { Icon: md_1.MdClose, onClick: onCloseButtonClick })] })));
}
exports.ModalHeader = ModalHeader;
//# sourceMappingURL=ModalHeader.js.map